import PropTypes from 'prop-types';
import { getText } from 'helpers/language-helper';
import Audio from 'components/ui/audio/audio';
import './carousel.scss';

const Carousel = ({taskId, currentStepId, languageId, optionType, options, selectOption, deviceInfo}) => {


	return (
		<div className="Carousel">
			<div className='Carousel-options'>
				{options.map((optionData) => {
					return (
						<div key={optionData.id}
							className={'Carousel-option ' + optionType + ' ' + deviceInfo.orientation}
							onClick={() => {selectOption(optionData.id);}}
						>
							<span>{getText(optionData.text, languageId)}</span>
							<div className='Carousel-optionAudio'>
								<Audio 
									type='task-option'
									fileName={languageId + '-' + taskId + '-' + currentStepId + '-' + optionData.id}
								/>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

Carousel.propTypes = {
	taskId: PropTypes.string.isRequired,
	currentStepId: PropTypes.string.isRequired,
	languageId: PropTypes.string.isRequired,
	optionType: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	selectOption: PropTypes.func.isRequired,
	deviceInfo: PropTypes.object.isRequired,
};

export default Carousel;
